/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import * as HERBUI from "react-bootstrap";
import "../loginandlandingpage.css";
import * as Yup from 'yup';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { AUTHENTICATION_URL, LOGIN_DOMAIN, } from "../Api/APIURLS";
import { useDispatch } from "react-redux";
import { CommonAjaxPostLoginRequest } from '../Api/CommonAjaxUtils'
import { origins } from "../components/Functions";
import MobileNumbersPopUp from "./MobileNumbersPopUp";
import PensionsMobileNumbersPopUp from "./PensionsMobileNumbersPopUp";

var createHost = require('cross-domain-storage/host');
var createGuest = require('cross-domain-storage/guest');


const Login = () => {
  var storageHost = null;
  var mainAppguest = null;
  const dispatch = useDispatch();
  const history = useHistory();
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [showpopup, setShowPopup] = useState(false);
  const [showPensionspopup, setShowPensionsPopup] = useState(false);

  // FIXED: use pwd instead of password
  const intialValues = { user_id: "", login_pwd: "" };

  const validationSchema = Yup.object({
    user_id: Yup.string().required("Required"),
    login_pwd: Yup.string().required("Required"),
  });

  useEffect(() => {
    localStorage.removeItem("passwordExpiry");
    storageHost = createHost(
      origins.map((origin) => ({ origin, allowedMethods: ["get", "set", "remove"] }))
    );
  }, []);

  const formik = useFormik({
    initialValues: intialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      

      const trimmedValues = {
        user_id: values.user_id.trim(),
        login_pwd: values.login_pwd.trim(),
      };
      localStorage.removeItem("token");
      localStorage.removeItem("serviceList");
      localStorage.clear();
      localStorage.setItem("userId", trimmedValues.user_id);
      localStorage.setItem("userName", trimmedValues.user_id);
      const sendValues = {
        username: trimmedValues.user_id,
        password: trimmedValues.login_pwd
      };

      CommonAjaxPostLoginRequest(AUTHENTICATION_URL, sendValues, dispatch, history).then(
        (response) => {
          if (response) {
            if (response && response.message) {
              localStorage.setItem(
                "expirationErrorMsg",
                JSON.stringify(response?.message)
              );
            }
          
            localStorage.setItem("token", JSON.stringify(response.access_token));
            localStorage.setItem("refresh_token", JSON.stringify(response.refresh_token));
            localStorage.setItem("userData", JSON.stringify(response));
            localStorage.setItem("userName", JSON.stringify(sendValues.username));
            localStorage.setItem("reloaded", "false");

            mainAppguest = createGuest(LOGIN_DOMAIN);
            let displayName = "";

            const base64Url = response?.access_token.split(".")[1];
            if (base64Url !== undefined) {
              const base64 = base64Url.replace("-", "+").replace("_", "/");
              displayName = JSON.parse(window.atob(base64)).name;
            
              localStorage.setItem("displayName", JSON.stringify(displayName));
            }

            mainAppguest.set("token", JSON.stringify(response.access_token), () => { });
            mainAppguest.set("displayName", JSON.stringify(displayName), () => { });
            mainAppguest.set("userData", JSON.stringify(response), () => { });
            mainAppguest.set("refresh_token", JSON.stringify(response.refresh_token), () => { });
            mainAppguest.set("userId", JSON.stringify(sendValues.username), () => { });

            history.push("/dashboard");
          } else {
            dispatch({
              type: "HIDE_SPINNER",
              payload: { key: "showSpinner", value: false },
            });

            setShowErrorMsg(true);
            formik.resetForm();
          }
        }
      );
    },
  });

  const togglePassword = () => {
    setPasswordType((p) => (p === "password" ? "text" : "password"));
  };

  function knowYourChallan() {
    history.push("/knowYourCfmsId");
  }
  function presidentialOrder() {
    history.push("/presidentialOrder");
  }
  function forgotPassword() {
    history.push("/forgotPassword");
  }
  function gotoServiceAssociationPage() {
    history.push("/serviceassociation");
  }
  function gos() {
    history.push("/gos");
  }
  function newAlerts() {
    history.push("/budgetRelatedPdfDetails");
  }
  const apfrsMobileApp = () => {
    history.push("/mobileApp");
  };
  function openPopup() {
   
    setShowPopup(true);
  }
  function openPensionsPopup() {
   
    setShowPensionsPopup(true);
  }
  const nidhiUserManualsApp = () => {
    history.push("/nidhiUserManuals")
  }
  const handleClose = () => setShowPopup(false);
  const handleClosePensions = () => setShowPensionsPopup(false);
  return (
    <>
      <FormikProvider value={formik}>
        <HERBUI.Navbar collapseOnSelect expand="lg" className="HERB-Top-Nav" variant="dark">
          <HERBUI.Container fluid>
            <HERBUI.Navbar.Brand href="/login">
              <img src="img/herb.svg" width="250" height="45" className="d-inline-block align-top" alt="NIDHI" />
            </HERBUI.Navbar.Brand>
            <HERBUI.Navbar.Toggle className="bg-secondary" aria-controls="responsive-navbar-nav" />
            <HERBUI.Navbar.Collapse id="responsive-navbar-nav navbar_txt" style={{ marginRight: "30px" }}>
              <HERBUI.Nav className="me-auto "></HERBUI.Nav>
              <HERBUI.Nav className="">
                {/* <HERBUI.Nav.Link href={"https://epts.ap.gov.in/opts/login.html"} target="_blank" rel="noreferrer" className="nav_link1" >
                  <b>
                    HR Mapping<img src="../img/gif_new.gif" alt="new" />
                  </b>
                </HERBUI.Nav.Link> */}
                <HERBUI.Nav.Link onClick={presidentialOrder} className="nav_link1">
                  <b>Presidential Order, 2025<img src="../img/gif_new.gif" alt="new" /></b>
                </HERBUI.Nav.Link>
                <HERBUI.Nav.Link
                  className="nav_link1"
                  onClick={() => nidhiUserManualsApp()}
                // onClick={() => navigate("/usermanuals")}
                >
                  <b>NIDHI User Manuals <img src="../img/gif_new.gif" alt="new" /></b>
                </HERBUI.Nav.Link>
                <HERBUI.Nav.Link onClick={gotoServiceAssociationPage} className="nav_link1">
                  <b>Service Association</b>
                </HERBUI.Nav.Link>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <HERBUI.Nav.Link onClick={knowYourChallan} className="nav_link1">
                  <b>Know Your CFMS ID</b>
                </HERBUI.Nav.Link>
                &nbsp;&nbsp;&nbsp;&nbsp;

                <HERBUI.Nav.Link onClick={gos} className="nav_link1">
                  <b>GOs, Circulars, Memos</b>
                </HERBUI.Nav.Link>

                <HERBUI.Nav.Link onClick={newAlerts} className="nav_link1">
                  <b>Budget 2026-27
                    {/* <img src="../img/gif_new.gif" alt="new" /> */}
                  </b>
                </HERBUI.Nav.Link>

                <HERBUI.NavDropdown
                  title={<b>Mobile Apps</b>}
                  id="mobile-apps-dropdown"
                  className="nav_link1"
                >
                  <HERBUI.NavDropdown.Item
                    href="https://appstore.nidhi.apcfss.in/iOSHerb.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download Employee Mobile APP
                  </HERBUI.NavDropdown.Item>

                  <HERBUI.NavDropdown.Divider />

                  <HERBUI.NavDropdown.Item
                    onClick={() => apfrsMobileApp()}
                  >
                    APFRS Mobile APP
                  </HERBUI.NavDropdown.Item>
                </HERBUI.NavDropdown>


              </HERBUI.Nav>
            </HERBUI.Navbar.Collapse>
          </HERBUI.Container>
        </HERBUI.Navbar>

        <HERBUI.Container fluid className="test-bg">
          <HERBUI.Row>
            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
              <img src="img/corner.svg" className="corner" alt="dots" />

              {/* ✔ Dummy fields OUTSIDE form */}
              <input
                type="text"
                name="dummy_username"
                autoComplete="username"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="dummy_password"
                autoComplete="new-password"
                style={{ display: "none" }}
              />
              <div className="main_form" autoComplete="off">
                <form className="form_adjust" autoComplete="off"
                  onSubmit={formik.handleSubmit} >
                  <div className="inner-herbpage-service-title-sub-np">
                    <h1 style={{ fontSize: "22px" }}> Login</h1>
                  </div>

                  {/* Username */}
                  <HERBUI.InputGroup className="mb-3 floating form-floating ">
                    <Field name="user_id" id="user_id" type="text" placeholder="username"
                      maxLength={15} className="form-control rounded" autoComplete="off"
                      value={formik.values.user_id}
                      onChange={(e) => {
                        formik.setFieldValue("user_id", e.target.value);
                        setShowErrorMsg(false);
                        localStorage.removeItem("loginFailErrorMsg");
                      }} />
                    <ErrorMessage name="user_id" className="text-error" component="div" />
                  </HERBUI.InputGroup>

                  {/* Password */}
                  <HERBUI.InputGroup className="mb-3 form-floating">
                    <input placeholder="Password" name="login_pwd" id="login_pwd" type={passwordType} className="form-control rounded"
                      autoComplete="new-password" value={formik.values.login_pwd}
                      onChange={(e) => {
                        formik.setFieldValue("login_pwd", e.target.value);
                        setShowErrorMsg(false);
                        localStorage.removeItem("loginFailErrorMsg");
                      }}
                    />
                    <label htmlFor="credential">Password</label>

                    <HERBUI.InputGroup.Text id="basic-addon2" className="basic-addon2">
                      {passwordType === "password" ? (
                        <FaEyeSlash onClick={togglePassword} />
                      ) : (
                        <FaEye onClick={togglePassword} />
                      )}
                    </HERBUI.InputGroup.Text>

                    <ErrorMessage name="login_pwd" className="text-error" component="div" />
                  </HERBUI.InputGroup>

                  <div className="d-grid gap-2">
                    <HERBUI.Button
                      variant="primary"
                      type="submit"
                      className="btn_primary rounded signin-bg"
                    >
                      Sign in
                    </HERBUI.Button>

                    <a
                      className="text-center forgot mb-4"
                      onClick={forgotPassword}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          forgotPassword();
                        }
                      }}
                    >
                      Forgot Password ?
                    </a>
                    {/* <div
                      style={{
                        marginTop: "15px",
                        padding: "12px 15px",
                        background: "#FCE4EC",       // Light magenta/pink background
                        border: "1px solid #E91E63", // Magenta border
                        borderLeft: "5px solid #C2185B", // Dark magenta left border
                        borderRadius: "6px",
                        fontSize: "13px",
                        color: "#880E4F",            // Dark magenta text
                        textAlign: "justify",
                        lineHeight: "1.5",
                      }}
                    >
                      <span style={{ color: "#d32f2f", fontWeight: "bold" }}>Note:</span>{" "}
                      A service titled <strong>"USC Number Confirmation"</strong> has been developed
                      in <strong>CFMS</strong> to capture the Unique Service Connection (USC) details used by DDOs.
                      Confirmation of USC details is mandatory for the implementation of the prepaid
                      metering system. All DDOs are requested to complete the USC confirmation to
                      avoid any inconvenience. If you have already completed the USC confirmation,
                      kindly ignore this notification.
                    </div> */}
                  </div>




                  {showErrorMsg && (
                    <div className="row">
                      <div className="col-12">
                        <div
                          className="alert alert-danger alert-dismissible fade show"
                          role="alert"
                        >
                          <strong>{localStorage.getItem("loginFailErrorMsg")} </strong>
                          <button
                            type="button"
                            onClick={() => setShowErrorMsg(false)}
                            className="btn btn-close"
                            data-dismiss="alert"
                          ></button>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>

            </HERBUI.Col>
          </HERBUI.Row>
        </HERBUI.Container>

        <MobileNumbersPopUp showpopup={showpopup} handleClose={handleClose} />
        <PensionsMobileNumbersPopUp showpopup={showPensionspopup} handleClose={handleClosePensions} />
      </FormikProvider>
    </>
  );
};
export default Login;
